import { TabsContent } from '@/components/ui/tabs';
import { EntityDocumentBrowser } from '@/components/documents/DocumentBrowser';
import { Fund } from '@/types';
import { EntityType } from '@/types/document';

interface DocumentsTabProps {
  fund: Fund;
}

export function FundDocumentsTab({ fund }: DocumentsTabProps) {
  return (
    <TabsContent value="files" className="space-y-4">
      {fund && (
        <EntityDocumentBrowser
          entityType={EntityType.FUND}
          entityId={fund.id}
          entityName={fund?.display_name || fund?.name || ''}
          showHeader={false}
        />
      )}
    </TabsContent>
  );
}
